export const humanReadableMethodsLog = new Map([
    ['admin_ask_plug_to_reconnect', 'Main loop'],
    ['admin_change_heating_algo', 'Heating'],
    ['admin_create_admin', 'Create admin'],
    ['admin_create_group', 'Create group'],
    ['admin_delete_account', 'Delete user'],
    ['admin_delete_device_cache', 'Clean cache'],
    ['admin_delete_group', 'Delete group'],
    ['admin_delete_phantoms', 'Delete phantoms'],
    ['admin_device_reset_abc', 'Recalibrate CO2'],
    ['admin_dissociate_module', 'Dissociate'],
    ['admin_generate_qrcode', 'QRCode'],
    ['admin_migrate_data', 'Migrate data'],
    ['admin_modify_device_behavior', 'Behavior'],
    ['admin_modify_group', 'Device group'],
    ['admin_order_device_reboot', 'Reboot'],
    ['admin_remove_admin', 'Remove admin'],
    ['admin_reset_device', 'Reset'],
    ['admin_send_vpn_command', 'VPN'],
    ['admin_set_data_offset', 'Offset'],
    ['admin_set_debug_status', 'Debug'],
    ['admin_toggle_device_dump', 'Dump'],
    ['admin_toggle_right', 'Admin right'],
]);
